/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Announcement } from '../models/announcement';
import { deleteServiceProviderAnnouncement } from '../fn/service-provider/delete-service-provider-announcement';
import { DeleteServiceProviderAnnouncement$Params } from '../fn/service-provider/delete-service-provider-announcement';
import { deleteServiceProviderOrganizations } from '../fn/service-provider/delete-service-provider-organizations';
import { DeleteServiceProviderOrganizations$Params } from '../fn/service-provider/delete-service-provider-organizations';
import { getServiceProviderAnnouncement } from '../fn/service-provider/get-service-provider-announcement';
import { GetServiceProviderAnnouncement$Params } from '../fn/service-provider/get-service-provider-announcement';
import { getServiceProviderOrganizationAdmins } from '../fn/service-provider/get-service-provider-organization-admins';
import { GetServiceProviderOrganizationAdmins$Params } from '../fn/service-provider/get-service-provider-organization-admins';
import { patchServiceProviderAnnouncement } from '../fn/service-provider/patch-service-provider-announcement';
import { PatchServiceProviderAnnouncement$Params } from '../fn/service-provider/patch-service-provider-announcement';
import { postServiceProviderAnnouncement } from '../fn/service-provider/post-service-provider-announcement';
import { PostServiceProviderAnnouncement$Params } from '../fn/service-provider/post-service-provider-announcement';
import { postServiceProviderOrganizationAdmin } from '../fn/service-provider/post-service-provider-organization-admin';
import { PostServiceProviderOrganizationAdmin$Params } from '../fn/service-provider/post-service-provider-organization-admin';
import { ServiceProviderOrganizationAdmin } from '../models/service-provider-organization-admin';
import { ServiceProviderOrganizationAdmins } from '../models/service-provider-organization-admins';


/**
 * Service provider operations including announcement management and organization administration
 */
@Injectable({ providedIn: 'root' })
export class ServiceProviderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `deleteServiceProviderOrganizations()` */
  static readonly DeleteServiceProviderOrganizationsPath = '/service-provider/organizations/{organizationKey}';

  /**
   * delete an organization.
   *
   * Delete an organization. The organization is first deactivated and
   * after 10 weeks deleted.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteServiceProviderOrganizations()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteServiceProviderOrganizations$Response(params: DeleteServiceProviderOrganizations$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteServiceProviderOrganizations(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * delete an organization.
   *
   * Delete an organization. The organization is first deactivated and
   * after 10 weeks deleted.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteServiceProviderOrganizations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteServiceProviderOrganizations(params: DeleteServiceProviderOrganizations$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteServiceProviderOrganizations$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getServiceProviderOrganizationAdmins()` */
  static readonly GetServiceProviderOrganizationAdminsPath = '/service-provider/organizations/{organizationKey}/organization-admins';

  /**
   * Get all organization admins of an organization.
   *
   * Return all organization admins (name and email address) of an organization.
   * API keys and API clients are not returned.
   * This endpoint can only be used by service providers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceProviderOrganizationAdmins()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceProviderOrganizationAdmins$Response(params: GetServiceProviderOrganizationAdmins$Params, context?: HttpContext): Observable<StrictHttpResponse<ServiceProviderOrganizationAdmins>> {
    const obs = getServiceProviderOrganizationAdmins(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all organization admins of an organization.
   *
   * Return all organization admins (name and email address) of an organization.
   * API keys and API clients are not returned.
   * This endpoint can only be used by service providers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getServiceProviderOrganizationAdmins$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceProviderOrganizationAdmins(params: GetServiceProviderOrganizationAdmins$Params, context?: HttpContext): Observable<ServiceProviderOrganizationAdmins> {
    const resp = this.getServiceProviderOrganizationAdmins$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ServiceProviderOrganizationAdmins>): ServiceProviderOrganizationAdmins => r.body)
    );
  }

  /** Path part for operation `postServiceProviderOrganizationAdmin()` */
  static readonly PostServiceProviderOrganizationAdminPath = '/service-provider/organizations/{organizationKey}/organization-admins';

  /**
   * Create an additional organization admin for an organization.
   *
   * Create a new user with the roles organization_admin and site_admin
   * for an existing organization, e.g. to give a locked out organization
   * access to Cloud4Log again. The new admin gets access to all
   * organization sites of the organization and receives an email to set
   * the password, like every new user.
   * If a user of the organization with the email address already exists
   * and is no organization admin, the user keeps its roles and gets the
   * additional roles organization_admin and site_admin on the organization
   * and on all organization sites. Sites the user had no access to are
   * added (incl. shared remote sites), like for a new organization admin.
   * The user receives a notification email.
   * Other existing users are rejected with 409:
   * USER_IS_ALREADY_ORGANIZATION_ADMIN, USER_IN_OTHER_ORGANIZATION,
   * USER_NOT_ACTIVE or USER_WITH_EMAIL_ADDRESS_EXISTS (e.g. service
   * provider, API key, API client).
   * This endpoint can only be used by service providers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postServiceProviderOrganizationAdmin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postServiceProviderOrganizationAdmin$Response(params: PostServiceProviderOrganizationAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<ServiceProviderOrganizationAdmin>> {
    const obs = postServiceProviderOrganizationAdmin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create an additional organization admin for an organization.
   *
   * Create a new user with the roles organization_admin and site_admin
   * for an existing organization, e.g. to give a locked out organization
   * access to Cloud4Log again. The new admin gets access to all
   * organization sites of the organization and receives an email to set
   * the password, like every new user.
   * If a user of the organization with the email address already exists
   * and is no organization admin, the user keeps its roles and gets the
   * additional roles organization_admin and site_admin on the organization
   * and on all organization sites. Sites the user had no access to are
   * added (incl. shared remote sites), like for a new organization admin.
   * The user receives a notification email.
   * Other existing users are rejected with 409:
   * USER_IS_ALREADY_ORGANIZATION_ADMIN, USER_IN_OTHER_ORGANIZATION,
   * USER_NOT_ACTIVE or USER_WITH_EMAIL_ADDRESS_EXISTS (e.g. service
   * provider, API key, API client).
   * This endpoint can only be used by service providers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postServiceProviderOrganizationAdmin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postServiceProviderOrganizationAdmin(params: PostServiceProviderOrganizationAdmin$Params, context?: HttpContext): Observable<ServiceProviderOrganizationAdmin> {
    const resp = this.postServiceProviderOrganizationAdmin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ServiceProviderOrganizationAdmin>): ServiceProviderOrganizationAdmin => r.body)
    );
  }

  /** Path part for operation `postServiceProviderAnnouncement()` */
  static readonly PostServiceProviderAnnouncementPath = '/service-provider/announcements';

  /**
   * Create a global announcement.
   *
   * Create a new global announcement visible to all users.
   * This endpoint can only be used by service providers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postServiceProviderAnnouncement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postServiceProviderAnnouncement$Response(params: PostServiceProviderAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<Announcement>> {
    const obs = postServiceProviderAnnouncement(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a global announcement.
   *
   * Create a new global announcement visible to all users.
   * This endpoint can only be used by service providers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postServiceProviderAnnouncement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postServiceProviderAnnouncement(params: PostServiceProviderAnnouncement$Params, context?: HttpContext): Observable<Announcement> {
    const resp = this.postServiceProviderAnnouncement$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Announcement>): Announcement => r.body)
    );
  }

  /** Path part for operation `getServiceProviderAnnouncement()` */
  static readonly GetServiceProviderAnnouncementPath = '/service-provider/announcements/{announcementKey}';

  /**
   * Get an announcement by key.
   *
   * Retrieve a specific global announcement by its key.
   * This endpoint can only be used by service providers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceProviderAnnouncement()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceProviderAnnouncement$Response(params: GetServiceProviderAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<Announcement>> {
    const obs = getServiceProviderAnnouncement(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get an announcement by key.
   *
   * Retrieve a specific global announcement by its key.
   * This endpoint can only be used by service providers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getServiceProviderAnnouncement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceProviderAnnouncement(params: GetServiceProviderAnnouncement$Params, context?: HttpContext): Observable<Announcement> {
    const resp = this.getServiceProviderAnnouncement$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Announcement>): Announcement => r.body)
    );
  }

  /** Path part for operation `deleteServiceProviderAnnouncement()` */
  static readonly DeleteServiceProviderAnnouncementPath = '/service-provider/announcements/{announcementKey}';

  /**
   * Delete an announcement.
   *
   * Delete a global announcement.
   * This endpoint can only be used by service providers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteServiceProviderAnnouncement()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteServiceProviderAnnouncement$Response(params: DeleteServiceProviderAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteServiceProviderAnnouncement(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete an announcement.
   *
   * Delete a global announcement.
   * This endpoint can only be used by service providers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteServiceProviderAnnouncement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteServiceProviderAnnouncement(params: DeleteServiceProviderAnnouncement$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteServiceProviderAnnouncement$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchServiceProviderAnnouncement()` */
  static readonly PatchServiceProviderAnnouncementPath = '/service-provider/announcements/{announcementKey}';

  /**
   * Update an announcement.
   *
   * Update a global announcement with partial data.
   * This endpoint can only be used by service providers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchServiceProviderAnnouncement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchServiceProviderAnnouncement$Response(params: PatchServiceProviderAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<Announcement>> {
    const obs = patchServiceProviderAnnouncement(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update an announcement.
   *
   * Update a global announcement with partial data.
   * This endpoint can only be used by service providers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchServiceProviderAnnouncement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchServiceProviderAnnouncement(params: PatchServiceProviderAnnouncement$Params, context?: HttpContext): Observable<Announcement> {
    const resp = this.patchServiceProviderAnnouncement$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Announcement>): Announcement => r.body)
    );
  }

}
